export default __webpack_public_path__ + "static/media/ALFALFA.3500418f.svg";